import { Box, Button, Stack, Typography } from "@mui/material";

import { type DayOfWeekSelectorProps } from "../../organisms/AddEventTimesModal/AddEventTimesModal.types";
import { DAYS_OF_WEEK } from "../../organisms/AddEventTimesModal/AddEventTimesModal.utils";

export const DayOfWeekSelector = ({ selectedDays, onDaysChange }: DayOfWeekSelectorProps) => {
  const toggleDay = (dayKey: number) => {
    const newDays = new Set(selectedDays);
    if (newDays.has(dayKey)) {
      newDays.delete(dayKey);
    } else {
      newDays.add(dayKey);
    }
    onDaysChange(newDays);
  };

  return (
    <Box>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Select days for new event times
      </Typography>
      <Stack direction="row" spacing={1}>
        {DAYS_OF_WEEK.map((day) => (
          <Button
            key={day.key}
            variant={selectedDays.has(day.key) ? "contained" : "outlined"}
            size="small"
            onClick={() => toggleDay(day.key)}
            sx={{
              borderRadius: "50%",
              fontSize: { sm: "0.875rem", xs: "0.75rem" },
              fontWeight: "bold",
              height: { sm: "40px", xs: "36px" },
              minWidth: { sm: "40px", xs: "36px" },
              p: { sm: 1, xs: 0 },
            }}
            title={day.fullName}
          >
            {day.label}
          </Button>
        ))}
      </Stack>
    </Box>
  );
};
